import { memo, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { navBarTabs } from '../../Utils/Navbar.utils';
import { AppContext } from '../../Context/AppContext';
import './PageLayout.scss';
import { deleteCookie, getCookie } from '../../Utils/CookieUtils';
import { KEYS } from '../../Constants/Constants';

export const PageLayout = memo((props: any) => {
  const { setModule } = useContext(AppContext);
  const { pathname } = useLocation();
  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress, accounts } = useMsal();
  const passwordRestTrigger = getCookie('passwordResetTrigger');
  useEffect(() => {
    const _module = navBarTabs()?.find((item: any) => pathname === item?.path);
    setModule(_module ?? {});
  }, [pathname, setModule]);
  useEffect(() => {
    if (inProgress !== InteractionStatus.None) return;
    if (!isAuthenticated && accounts.length === 0 && !passwordRestTrigger) {
      instance.loginRedirect();
    }
  }, [accounts.length, inProgress, instance, isAuthenticated, passwordRestTrigger]);
  if (passwordRestTrigger) {
    deleteCookie('passwordResetTrigger');
    window?.open(KEYS?.PASSWORD_RESET_REDIRECTION_URL, '_self')?.focus();
    return null;
  }
  return <div>{props?.children}</div>;
});
